export default {
    searchByEmployeeNameOrID: 'ค้นหาจากชื่อ, รหัสพนักงาน',
    statusAttendance: 'สถานะเข้างาน',
    search: 'ค้นหา',
    employeeId: 'รหัสพนักงาน',
    employeeName: 'ชื่อ - นามสกุล',
    bureau: 'สำนักงาน',
    date: 'วันที่',
    locationIn: 'สถานที่เข้า',
    checkinTime: 'เวลาเข้า',
    locationOut: 'สถานที่ออก',
    checkoutTime: 'เวลาออก',
    totalHour: 'จำนวน',
    status: 'สถานะ',
    exportTXT: 'ดาวน์โหลด Text File',
    exportPDF: 'ดาวน์โหลด PDF',
    exportExcel: 'ดาวน์โหลด Excel',
    congratulation: 'ยินดีด้วย',
    somethingWrong: 'เกิดข้อผิดพลาด'
}
